/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import Button from '@roo/roo/Button'
import { useTranslation } from '@sailor/i18n-web'
import { useRequest } from 'ahooks'
import { getRulePackageList } from './utils/api'
import { IRulePackage } from './utils/types'
import { getI18nTime } from '@/common/utils/i18nFuncs'
import { useJumpRuleDetailPage } from './pages/detail'
import { getEmailName, isEqualString } from '@/common/utils'
import { getPeridTimeText } from './pages/detail/components/PeriodRule'
import { Tooltip } from '@roo/roo'
import TipText from '@/components/TipText'
import DeleteRule from './components/DeleteRule'
import CommonTable from '@/components/CommonTable'
import IssuanceInfoRender from './components/IssuanceInfoRender'
import { BudgetFeeConfigTypeEnum, BudgetFeeTypeEnum } from './pages/detail/utils'
import { useNavigate } from 'react-router-dom'
import AddressRuleRender from './components/AddressRuleRender'
import { transPickup2Delivery } from './pages/detail/components/AddressRule/PickupAddressRule'
import useRuleConfig, { ruleConfigAtomHook } from '@/common/recoil/atom/ruleConfigAtom'
import entFunctionConfigAtom from '@/common/recoil/atom/entFunctionConfigAtom'
import { getDateTimePattern } from '@/common/utils/i18n'
import { isEn } from '@/common/utils/i18nFuncs'
import dayjs from 'dayjs'
export default () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [pageInfo, setPageInfo] = useState({ pageNo: 1, pageSize: 20 })
  const { data: ruleListRes, loading, run } = useRequest(() => getRulePackageList({ ...pageInfo }), { manual: true })
  const jumpRuleDetailPage = useJumpRuleDetailPage()
  const refreshRuleConfig = ruleConfigAtomHook.useRefresh()
  const { showPickup } = useRuleConfig() || {}
  const refreshEntFunctonConfig = entFunctionConfigAtom.useRefresh()

  useEffect(run, [pageInfo]) // 分页信息改变时,重新请求数据

  useEffect(() => {
    refreshEntFunctonConfig()
    refreshRuleConfig()
  }, [])

  const columns = [
    { title: t('e_pc_rule_name', '规则名称'), dataIndex: 'rulePackageName',
      width: 200,
      render: (text:string) => <TipText text={text} />,
    },
    {
      title: t('e_pc_effect_time', '生效时间'), dataIndex: 'effectiveTimeRule',
      width: 200,
      render: (_:any, record: IRulePackage) =>  {
        const startTime = getI18nTime(record.effectiveTimeRule?.startTime as number)
        return startTime
      },
    },
    {
      title: t('e_pc_end_time', '结束时间'), dataIndex: 'effectiveTimeRule',
      width: 230,
      render: (_:any, record: IRulePackage) =>  {
        const endTime = isEqualString(record.effectiveTimeRule?.endTimeType, 2) ? t('e_pc_long_term', '长期有效') : getI18nTime(record.effectiveTimeRule?.endTime as number)
        return endTime
      },
    },
    { title: t('e_pc_issuance_info', '下发信息'), dataIndex: 'staffStatusRule',
      width: 300,
      render: (_:any, record: IRulePackage) => <IssuanceInfoRender record={record}/>,
    },
    { title: t('e_pc_apply_group', '适用人群'), dataIndex: 'assignInfo',
      width: 200,
      render: (_:any, record: IRulePackage) => {
        const { assignAll, assignStaffList, assignDepartmentList, assignGroupList } = record.assignInfo || {}
        if (isEqualString(record.budgetFeeRule?.amountFrom, BudgetFeeConfigTypeEnum.EXCEL)) return '--'
        if (assignAll) return t('e_pc_all', '全部')
        const staffNames = assignStaffList?.map(item => `${item.staffName}${getEmailName(item.email)}`).join(',')
        const departmentNames = assignDepartmentList?.map(item => item.departmentDisplayName || item.departmentName).join(',')
        const groupNames = assignGroupList?.map(item => item.groupName).join(',')
        return (
          <div>
            {staffNames && <TipText text={`${t('e_pc_specific_staff', '特定员工')}: ${staffNames}`}></TipText>}
            {departmentNames && <TipText placement="bottom" text={`${t('e_pc_specific_dept', '特定部门')}: ${departmentNames}`}></TipText>}
            {groupNames && <TipText placement="bottom" text={`${t('e_pc_specific_group1', '特定分组')}: ${groupNames}`}></TipText>}
          </div>
        )
      },

    },

    {
      title: t('e_pc_available_period', '可用时段'),
      dataIndex: 'repastPeriodRule',
      width: 300,
      ellipsis: true,
      render: (_:any, record: IRulePackage) => {
        const { checkRepastPeriod, repastPeriodList } = record.repastPeriodRule || {}
        const texts = getPeridTimeText(repastPeriodList || [])
        const isMultiPeriod = texts?.length > 1
        const TimeItem = (item: {weekText: string, timeText:string}) => (
          <li style={{ listStyleType: 'disc' }}>
            <div>{item.weekText}</div>
            <div>{item.timeText}</div>
          </li>
        )
        return (
          checkRepastPeriod &&  texts.length > 0
            ? (
              <Tooltip content={<ul style={{ paddingLeft: '12px' }}>{texts.map(item => <TimeItem {...item} />)}</ul>}>
                <div >
                  <div  style={{ whiteSpace: 'nowrap', width: '100%', overflow: 'hidden', textOverflow: 'ellipsis' }}>{texts[0].weekText}</div>
                  <div  style={{ whiteSpace: 'nowrap', width: '100%', overflow: 'hidden', textOverflow: 'ellipsis' }}>{texts[0].timeText}</div>
                  {isMultiPeriod && <div>,...</div>}
                </div>
              </Tooltip>
            )
            : t('e_pc_no_limit', '不限制')
        )
      },
    },
    {
      title: t('e_pc_delivery_address', '送餐地址'), dataIndex: 'deliveryAddressRule',
      width: 300,
      render: (_:any, record: IRulePackage) => <AddressRuleRender data={record.deliveryAddressRule}/>,
    },
    showPickup !== false && {
      title: t('e_pc_pickup_address', '自取地址'), dataIndex: 'pickupAddressRule',
      width: 300,
      render: (_:any, record: IRulePackage) => <AddressRuleRender data={transPickup2Delivery(record.pickupAddressRule)}/>,
    },
    { title: t('e_pc_operation', '操作'), dataIndex: 'rulePackageId',
      fixed: 'right',
      width: isEn() ? 300 : 210,
      render: (_:any, record: IRulePackage) => {
        // 预算津贴类型（budgetFeeType=1）才显示余额管理入口
        const isBudgetFee = isEqualString(record.budgetFeeType, BudgetFeeTypeEnum.BUDGET)
        // 规则未生效：startTime 大于当前时间
        const isNotStarted = record.effectiveTimeRule?.startTime !== null && record.effectiveTimeRule?.startTime !== undefined && dayjs().isBefore(record.effectiveTimeRule.startTime)
        const handleBalanceMgmt = () => {
          const periodType = record.budgetFeeRule?.periodType ?? 0
          const budgetPolicyNo = record?.budgetFeeRule?.budgetPolicyNo || ''
          const rulePackageId = record.rulePackageId || ''
          navigate(`/rule/balance?periodType=${periodType}&budgetPolicyNo=${budgetPolicyNo}&rulePackageId=${rulePackageId}`)
        }
        const balanceMgmtBtn = (
          <Button type="brand-text" disabled={isNotStarted} onClick={isNotStarted ? undefined : handleBalanceMgmt}>
            {t('e_pc_balance_mgmt', '余额管理')}
          </Button>
        )
        return (
          <div>
            <Button type="brand-text" onClick={() => {jumpRuleDetailPage({ ruleId: record.rulePackageId })}}>
              {t('e_pc_edit', '编辑')}
            </Button>
            {isBudgetFee && (
              <>
                &ensp;&ensp;&ensp;
                {isNotStarted ? (
                  <Tooltip content={t('e_pc_balance_management_ban', '津贴未生效，余额管理暂不可用')} placement="top">
                    <span>{balanceMgmtBtn}</span>
                  </Tooltip>
                ) : balanceMgmtBtn}
              </>
            )}
            &ensp;&ensp;&ensp;
            <DeleteRule
              rulePackageId={record.rulePackageId as number}
              onSuccess={run}
            />
          </div>
        )
      },
    },
  ]

  return (
    <div className="page-content" style={{ display: 'flex', flexDirection: 'column' }}>
      <div>
        <div className="page-title">
          {t('e_pc_rule_management', '规则管理')}
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '24px' }}>
          <div></div>
          <Button type="brand" onClick={() => jumpRuleDetailPage({})} >
            {t('e_pc_create_rule', '创建规则')}
          </Button>
        </div>
      </div>
      <CommonTable
        style={{ marginTop: 16 }}
        rowKey="rulePackageId"
        columns={columns}
        data={ruleListRes?.result || []}
        loading={loading}
        pagination={{
          total: ruleListRes?.totalCount,
          pageSize: pageInfo.pageSize,
          onChange: (pageNo: number, pageSize: number) => setPageInfo({ pageNo, pageSize }),
        }}
      />
    </div>
  )
}
